import {
  BarChart3, Bot, Briefcase, Building2, Cable, CreditCard, Code2, Cog, FileBarChart, Filter, Gauge, GitBranch, Globe, KeyRound, Layers, LayoutDashboard, LineChart, Link2, MessageSquare,
  Palette, Plug, Radio, Receipt, Settings, ShieldCheck, Sprout, Target, Users, Video, Workflow, Activity, ScrollText, FileInput, UsersRound, Megaphone, Calculator, SlidersHorizontal, LifeBuoy, Mail, Webhook,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission?: string;
  /** Só marca ativo em correspondência exata (para itens com subrotas irmãs, ex.: Integrações vs Meta Ads). */
  end?: boolean;
}
export interface NavGroup {
  /** Identificador estável do módulo (submenu recolhível). Ausente = grupo achatado (itens no topo). */
  id?: string;
  label?: string;
  /** Ícone do módulo no cabeçalho do submenu. */
  icon?: LucideIcon;
  items: NavItem[];
}

export const APP_NAV: NavGroup[] = [
  { items: [{ to: "/app/overview", label: "Visão geral", icon: LayoutDashboard, permission: "analytics:read" }] },
  {
    id: "aquisicao",
    label: "Aquisição",
    icon: Megaphone,
    items: [
      { to: "/app/acquisition", label: "Campanhas", icon: Target, permission: "analytics:read" },
      { to: "/app/creatives", label: "Criativos", icon: Video, permission: "analytics:read" },
      { to: "/app/attribution", label: "Atribuição", icon: GitBranch, permission: "analytics:read" },
    ],
  },
  {
    id: "comercial",
    label: "Comercial",
    icon: Briefcase,
    items: [
      { to: "/app/leads", label: "Leads", icon: UsersRound, permission: "leads:read" },
      { to: "/app/opportunities", label: "Oportunidades", icon: Layers, permission: "leads:read" },
      { to: "/app/revenue", label: "Receita", icon: Receipt, permission: "revenue:read" },
      { to: "/app/pipelines", label: "Pipelines", icon: Filter, permission: "leads:read" },
    ],
  },
  {
    id: "conexoes",
    label: "Conexões",
    icon: Cable,
    items: [
      { to: "/app/integrations/meta", label: "Meta Ads", icon: Megaphone, permission: "integrations:manage" },
      { to: "/app/integrations", label: "Integrações", icon: Plug, permission: "integrations:manage", end: true },
    ],
  },
  {
    id: "crescimento",
    label: "Crescimento",
    icon: Sprout,
    items: [
      { to: "/app/forms", label: "Formulários", icon: FileInput, permission: "integrations:manage" },
      { to: "/app/automations", label: "Automações", icon: Workflow, permission: "automations:manage" },
      { to: "/app/audiences", label: "Públicos", icon: Users, permission: "audiences:manage" },
      { to: "/app/tracking/sites", label: "Pixel e sites", icon: Radio, permission: "tracking:manage" },
      { to: "/app/tracking/links", label: "Links", icon: Link2, permission: "tracking:manage" },
      { to: "/app/tracking/events", label: "Eventos", icon: Activity, permission: "tracking:manage" },
    ],
  },
  {
    id: "analise",
    label: "Análise",
    icon: LineChart,
    items: [
      // Consolidado multi-workspace: a API exige vínculo de organização; usuários sem escopo recebem erro de autorização.
      { to: "/app/organization", label: "Organização", icon: Building2, permission: "analytics:read" },
      { to: "/app/planning", label: "Planejamento", icon: Calculator, permission: "analytics:read" },
      { to: "/app/reports", label: "Relatórios", icon: FileBarChart, permission: "analytics:read" },
    ],
  },
  {
    id: "config",
    label: "Configuração",
    icon: Cog,
    items: [
      { to: "/app/developers", label: "Desenvolvedores", icon: Code2, permission: "developers:manage" },
      { to: "/app/team", label: "Equipe", icon: Users, permission: "team:manage" },
      { to: "/app/billing", label: "Assinatura", icon: CreditCard, permission: "billing:read" },
      { to: "/app/settings", label: "Configurações", icon: Settings, permission: "settings:manage", end: true },
      { to: "/app/settings/workspaces", label: "Workspaces", icon: Building2, permission: "workspaces:manage" },
      { to: "/app/settings/custom-fields", label: "Campos personalizados", icon: SlidersHorizontal, permission: "settings:manage" },
      { to: "/app/settings/support", label: "Acesso de suporte", icon: LifeBuoy, permission: "support:grant" },
    ],
  },
];

export const ADMIN_NAV: NavGroup[] = [
  {
    items: [
      { to: "/admin/overview", label: "Visão geral", icon: Gauge, permission: "brand:read" },
      { to: "/admin/organizations", label: "Organizações", icon: Building2, permission: "brand:read" },
      { to: "/admin/plans", label: "Planos e preços", icon: Receipt, permission: "brand:billing" },
      { to: "/admin/billing", label: "Cobrança", icon: CreditCard, permission: "brand:billing" },
      { to: "/admin/branding", label: "Marca e domínio", icon: Palette, permission: "brand:manage" },
      { to: "/admin/email", label: "E-mail", icon: Mail, permission: "brand:manage" },
      { to: "/admin/team", label: "Equipe", icon: Users, permission: "brand:team" },
    ],
  },
];

export const MASTER_NAV: NavGroup[] = [
  {
    items: [
      { to: "/master/overview", label: "Visão geral", icon: BarChart3 },
      { to: "/master/brands", label: "Marcas", icon: Globe },
      { to: "/master/billing", label: "Cobrança atacado", icon: CreditCard },
      { to: "/master/whatsapp", label: "WhatsApp (QR)", icon: MessageSquare },
      { to: "/master/meta-webhook", label: "Webhook da Meta", icon: Webhook },
      { to: "/master/operations", label: "Operações", icon: Activity },
      { to: "/master/audit", label: "Auditoria e suporte", icon: ScrollText },
    ],
  },
];

export { Bot, KeyRound, ShieldCheck };
